import { render, staticRenderFns } from "./AgencyRenewal.vue?vue&type=template&id=45c19bab&scoped=true"
import script from "./AgencyRenewal.vue?vue&type=script&lang=js"
export * from "./AgencyRenewal.vue?vue&type=script&lang=js"
import style0 from "./AgencyRenewal.vue?vue&type=style&index=0&id=45c19bab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c19bab",
  null
  
)

export default component.exports